
export const destinos = [
  {
    ciudad: "Aruba",
    slug: "aruba",
    pais: "Aruba",
    hotel: "Aruba Hotel 4*",
    noches: 7,
    regimen: "Desayuno u All Inclusive",
    imagen: "/images/aruba.png",
    iconos: ["vuelo", "hotel", "desayuno", "allinclusivebebidas", "wifi", "asistencia"],
    serviciosIncluidos: [
      "Ruta aérea estimada: Mendoza - Aruba - Mendoza",
      "Compañía aérea: COPA/LATAM AIRLINES",
      "Clase cotizada 'BASIC'",
      "Incluye carry on 10K + artículo personal",
      "Traslados regulares de entrada y salida",
      "7 noches de alojamiento en Aruba Hotel 4* con desayuno u all inclusive",
      "Seguro Asistencia al Viajero: INCLUIDO. ASSIST CARD. AC150. COBERTURA USD 150.000"
    ],
    recomendaciones: [
      "Disfrutar de las playas de arena blanca y aguas cristalinas",
      "Explorar el centro histórico de Oranjestad",
      "Practicar deportes acuáticos como windsurf y buceo",
      "Visitar el Parque Nacional Arikok",
      "Conocer la cultura local y probar la gastronomía caribeña"
    ],
    descripcion: "Aruba es una isla paradisíaca en el Caribe holandés, famosa por sus playas de arena blanca, aguas cristalinas y clima perfecto durante todo el año. Con una mezcla única de cultura holandesa y caribeña, ofrece una experiencia tropical inolvidable con actividades acuáticas, vida nocturna vibrante y una hospitalidad excepcional."
  },
  {
    ciudad: "Bariloche",
    slug: "bariloche",
    pais: "Argentina",
    hotel: "Hotel 2*, 3*, 4*, 5*",
    noches: 5,
    regimen: "Desayuno",
    imagen: "/images/bariloche.webp",
    iconos: ["vuelo", "hotel", "desayuno", "asistencia", "excursiones"],
    serviciosIncluidos: [
      "Aéreo desde Mendoza",
      "Traslados aeropuerto hotel aeropuerto",
      "Alojamiento Hotel 2*, 3*, 4*, 5* con desayuno",
      "Excursiones: Circuito chico y Cerro Catedral, 7 lagos",
      "Asistencia al viajero",
      "Asistencia BELUTOURS 24/7 durante tu viaje"
    ],
    recomendaciones: [
      "Disfrutar del esquí en Cerro Catedral",
      "Recorrer el Circuito Chico",
      "Explorar los 7 lagos",
      "Visitar el Centro Cívico"
    ],
    descripcion: "San Carlos de Bariloche es el destino más visitado de la Patagonia, conocido por sus lagos cristalinos, montañas nevadas y centros de esquí de clase mundial. Un paraíso para los amantes de la naturaleza y los deportes de invierno."
  },
  {
    ciudad: "Buenos Aires",
    slug: "buenos-aires",
    pais: "Argentina",
    hotel: "3* con desayuno",
    noches: 3,
    regimen: "Desayuno",
    imagen: "/images/buenos-aires.webp",
    iconos: ["vuelo", "hotel", "desayuno", "asistencia"],
    itinerario: [
      "Aéreo desde Mendoza",
      "Alojamiento Hotel 2*, 3*, 4* o 5* con desayuno",
      "Excursiones opcionales por la ciudad",
      "Asistencia BELUTOURS 24/7 durante tu viaje"
    ],
    recomendaciones: [
      "Calzado cómodo para caminar.",
      "Tarjeta SUBE para transporte público.",
      "Reservar espectáculos con anticipación."
    ],
    descripcion:
      "Buenos Aires es la capital y ciudad más poblada de la República Argentina. Lugares de interés: Av. 9 de Julio, Av. Corrientes, Obelisco, Jardín Japonés, Bosques de Palermo, Tigre, La Boca, San Telmo, Puerto Madero."
  },
  {
    ciudad: "Cancún",
    slug: "cancun",
    pais: "México",
    hotel: "Grand Oasis Cancún 4*",
    noches: 7,
    regimen: "All inclusive",
    imagen: "/images/cancun.webp",
    iconos: ["vuelo", "hotel", "comidas", "allinclusivebebidas", "wifi", "asistencia"],
    itinerario: [],
    recomendaciones: [],
    descripcion: ""
  },
  {
    ciudad: "Iguazú",
    slug: "iguazu",
    pais: "Argentina",
    hotel: "Hotel 2*, 3*, 4*, 5*",
    noches: 4,
    regimen: "Desayuno",
    imagen: "/images/iguazu.webp",
    iconos: ["vuelo", "hotel", "desayuno", "asistencia"],
    serviciosIncluidos: [
      "Aéreo desde Mendoza",
      "Traslados aeropuerto hotel aeropuerto",
      "Alojamiento Hotel 2*, 3*, 4*, 5* con desayuno",
      "Excursiones: Cataratas Argentinas, Cataratas Brasileras, Parque Das Aves, entre otras",
      "Asistencia al viajero",
      "Asistencia BELUTOURS 24/7 durante tu viaje"
    ],
    recomendaciones: [
      "Llevar ropa liviana e impermeable.",
      "Protector solar y repelente.",
      "Resguardar electrónicos del agua en pasarelas.",
      "NOTA: Las entradas a los parques no están incluidas y se pagan en destino"
    ],
    descripcion:
      "Parque Nacional Iguazú o Parque y Reserva Nacional Iguazú son los nombres con los que se conoce. La superficie de esta área protegida es de 67620 hectáreas, que se subdividen en 59945 hectáreas para el Parque Nacional y 7675 hectáreas para la Reserva Nacional. En esta última se encuentra un sector concesionado, llamado Área Cataratas del Parque Nacional Iguazú, destinado a brindar servicios turísticos de recepción de visitantes. El Parque Nacional Iguazú fue creado en 1934, con el objetivo de conservar el entorno y la biodiversidad de las cataratas del Iguazú, las cuales, en 2011, fueron elegidas como una de las «Siete maravillas naturales del mundo». El Parque Nacional Iguazú es un patrimonio mundial de la humanidad y una de las 7 maravillas naturales del mundo. Lugares de interés: Dutty Free Shop, Hito 3 Fronteras, Minas de Wanda, Ruinas de San Ignacio, Foz Do Iguazu, entre otros."
  },
  {
    ciudad: "Maceió",
    slug: "maceio",
    pais: "Brasil",
    hotel: "Palms Ponta Verde 4*",
    noches: 10,
    regimen: "Desayuno",
    imagen: "/images/maceio.webp",
    iconos: ["vuelo", "hotel", "desayuno", "asistencia"],
    itinerario: [],
    recomendaciones: [],
    descripcion: ""
  },
  {
    ciudad: "Miches",
    slug: "miches",
    pais: "República Dominicana",
    hotel: "Hotel 4*, 5*",
    noches: 7,
    regimen: "All Inclusive",
    imagen: "/images/miches.webp",
    iconos: ["vuelo", "hotel", "comidas", "allinclusivebebidas", "wifi", "asistencia"],
    serviciosIncluidos: [
      "Ruta aérea estimada: Mendoza - Punta Cana - Mendoza",
      "Compañía aérea: LATAM AIRLINES",
      "Clase cotizada 'LIGHT'",
      "Incluye carry on 12K + artículo personal",
      "Traslados regulares de entrada y salida",
      "7 noches de alojamiento en Miches Hotel 4*/5*",
      "Seguro Asistencia al Viajero: ASSIST CARD AC150",
      "Cobertura USD 150.000"
    ],
    recomendaciones: [
      "Llevar protector solar y ropa de playa",
      "Disfrutar de las playas de ensueño de Miches",
      "Explorar las actividades de naturaleza y aventura",
      "Conocer la cultura y la gente local"
    ],
    descripcion:
      "Miches, un pequeño y hermoso pueblo situado en la costa este de la República Dominicana, se ha convertido en uno de los destinos turísticos más populares de los últimos años. Su belleza natural, unas playas de ensueño y paisajes impresionantes atraen a visitantes de todo el mundo. Sin embargo, lo que hace de Miches un lugar especial no es solo su encanto natural, sino también su cultura y su gente. Esta zona es un verdadero paraíso que cuenta con una amplia variedad de actividades de naturaleza y aventura, así como unas playas impresionantes."
  },
  {
    ciudad: "Panamá",
    slug: "panama",
    pais: "Panamá",
    hotel: "Hotel 4*",
    noches: 7,
    regimen: "Desayuno",
    imagen: "/images/panama.webp",
    iconos: ["vuelo", "hotel", "desayuno", "asistencia"],
    serviciosIncluidos: [
      "Ruta aérea estimada: Mendoza - Panamá - Mendoza",
      "Compañía aérea: COPA AIRLINES",
      "Clase cotizada 'BASIC'",
      "Incluye carry on 10K + artículo personal",
      "Traslados regulares de entrada y salida",
      "7 noches de alojamiento en Panama Hotel 4*",
      "Seguro Asistencia al Viajero: ASSIST CARD AC150",
      "Cobertura USD 150.000"
    ],
    recomendaciones: [
      "Llevar ropa cómoda para caminar y pedalear",
      "Disfrutar del skyline con rascacielos de Latinoamérica",
      "Recorrer la Bahía de Panamá y disfrutar de la brisa del Pacífico",
      "Visitar sitios arqueológicos y senderos",
      "Explorar la historia colonial y la vida nocturna"
    ],
    descripcion:
      "Descubre la capital de Panamá, también conocida como Ciudad de Panamá. Aquí puedes pedalear frente a un skyline con algunos de los rascacielos más altos de Latinoamérica, disfrutar de la brisa del pacífico mientras recorres la Bahía de Panamá, caminar entre sitios arqueológicos y senderos, y ver la historia colonial y la noche cobrar vida en un mismo lugar. La capital de Panamá es un destino de alto contraste donde la vegetación, los pueblos indígenas y la vibrante vida citadina te esperan. Lugares para visitar en Panamá: Boquete, Isla Taboga, Bocas del Toro, Portobelo, Golfo de Chiquirí, etc."
  },
  {
    ciudad: "Playa del Carmen",
    slug: "playa-del-carmen",
    pais: "México",
    hotel: "Catalonia Yucatán Beach 4*",
    noches: 7,
    regimen: "All inclusive",
    imagen: "/images/playa.webp",
    iconos: ["vuelo", "hotel", "comidas", "allinclusivebebidas", "wifi", "asistencia"],
    serviciosIncluidos: [
      "Ruta aérea estimada: Mendoza - Cancún - Mendoza",
      "Compañía aérea: AEROMÉXICO / LATAM AIRLINES",
      "Clase cotizada 'BASIC'",
      "Incluye carry on 10K + artículo personal",
      "Traslados regulares de entrada y salida",
      "7 noches de alojamiento en Playa del Carmen Hotel Catalonia Yucatán Beach 4* con all inclusive",
      "Seguro Asistencia al Viajero: INCLUIDO. ASSIST CARD. AC150. COBERTURA USD 150.000"
    ],
    recomendaciones: [
      "Disfrutar de las playas de arena blanca y aguas turquesas",
      "Explorar la Quinta Avenida con sus tiendas y restaurantes",
      "Visitar las ruinas mayas de Tulum y Chichen Itzá",
      "Practicar snorkeling en los arrecifes de coral",
      "Disfrutar de la vida nocturna y los cenotes"
    ],
    descripcion: "Playa del Carmen, ubicada en la Riviera Maya de México, es un destino paradisíaco que combina playas de arena blanca, aguas turquesas del Caribe y una vibrante cultura mexicana. Con su famosa Quinta Avenida llena de tiendas, restaurantes y vida nocturna, ofrece experiencias únicas y recuerdos inolvidables. Desde aquí puedes explorar las antiguas ruinas mayas de Tulum, nadar en cenotes cristalinos, bucear en arrecifes de coral y relajarte en playas de clase mundial. El Hotel Catalonia Yucatán Beach 4* ofrece un all inclusive completo con acceso directo a la playa, múltiples restaurantes, bares y entretenimiento."
  },
  {
    ciudad: "Punta Cana",
    slug: "punta-cana",
    pais: "República Dominicana",
    hotel: "Bahía Príncipe Grand Turquesa 4*",
    noches: 10,
    regimen: "All inclusive",
    imagen: "/images/puntacana.webp",
    iconos: ["vuelo", "hotel", "comidas", "allinclusivebebidas", "wifi", "asistencia"],
    itinerario: [],
    recomendaciones: [],
    descripcion: ""
  },
  {
    ciudad: "Río de Janeiro",
    slug: "rio-de-janeiro",
    pais: "Brasil",
    hotel: "Astoria Copacabana 3*",
    noches: 7,
    regimen: "Desayuno",
    imagen: "/images/rio.webp",
    iconos: ["vuelo", "hotel", "desayuno", "asistencia"],
    itinerario: [],
    recomendaciones: [],
    descripcion: ""
  },
  {
    ciudad: "Salta",
    slug: "salta",
    pais: "Argentina",
    hotel: "Hotel 2*, 3*, 4*, 5*",
    noches: 4,
    regimen: "Desayuno",
    imagen: "/images/salta.webp",
    iconos: ["vuelo", "hotel", "desayuno", "asistencia"],
    serviciosIncluidos: [
      "Aéreo desde Mendoza",
      "Traslados aeropuerto hotel aeropuerto",
      "Alojamiento Hotel 2*, 3*, 4*, 5* con desayuno",
      "Excursiones: Cafayate, Salinas Grandes con Purmamarca, City, Tren de las nubes, entre otras",
      "Asistencia al viajero",
      "Asistencia BELUTOURS 24/7 durante tu viaje"
    ],
    recomendaciones: [
      "Lentes de sol y protector (la sal refleja mucho).",
      "Llevar agua: clima seco y altura.",
      "Campera rompe-viento: puede haber ráfagas."
    ],
    descripcion:
      "Salta, cuyo nombre original fue San Felipe de Lerma en el valle de Salta, es una ciudad del norte de Argentina, capital de la provincia homónima. Se encuentra ubicada en el sector norte del Valle de Lerma. Su superficie aproximada es de 120 km². Es también la ciudad más poblada de la provincia, la segunda del NOA y la séptima del país. Se encuentra ubicada al este de la cordillera de los Andes, en el Valle de Lerma, a 1187 m s. n. m., muy cerca del nacimiento del río Mojotoro y cruzada por el río Arenales. Lugares de interés: Plaza 9 de Julio, Cabildo, Catedral San Francisco, Cerro San Bernardo, Plaza San Martín, Cafayate, Cachi. Además, desde Salta salen excursiones que visitan las Salinas Grandes de Jujuy, Purmamarca, Tilcara."
  },
  // BRASIL
  {
    ciudad: "Buzios",
    slug: "buzios",
    pais: "Brasil",
    hotel: "Hotel Astoria Copacabana 3*",
    noches: 7,
    regimen: "Desayuno",
    imagen: "/images/buzios.webp",
    iconos: ["vuelo", "hotel", "desayuno", "asistencia"],
    serviciosIncluidos: [
      "Ruta aérea estimada: Mendoza - Rio de Janeiro - Mendoza",
      "Compañía aérea: AEROLINEAS ARGENTINAS",
      "Incluye carry on 10K + artículo personal",
      "Traslados regulares de entrada y salida",
      "7 noches de alojamiento en Rio de Janeiro Hotel Astoria Copacabana 3* con desayuno",
      "Seguro Asistencia al Viajero: INCLUIDO. ASSIST CARD. AC150. COBERTURA USD 150.000"
    ],
    recomendaciones: [
      "Disfrutar de las hermosas playas de Buzios",
      "Explorar el centro histórico de Rio de Janeiro",
      "Visitar el Cristo Redentor y Pan de Azúcar"
    ],
    descripcion: "Buzios es una encantadora península en el estado de Río de Janeiro, conocida por sus hermosas playas, vida nocturna vibrante y arquitectura colonial portuguesa. Es un destino perfecto para combinar relax y diversión."
  },
  {
    ciudad: "Natal",
    slug: "natal",
    pais: "Brasil",
    hotel: "Hotel Palms Ponta Verde by Tropicalis 4*",
    noches: 9,
    regimen: "Desayuno",
    imagen: "/images/natal.webp",
    iconos: ["vuelo", "hotel", "desayuno", "asistencia"],
    serviciosIncluidos: [
      "Ruta aérea estimada: Mendoza - Natal - Mendoza",
      "Compañía aérea: GOL LINHEAS AEREAS",
      "Incluye carry on 10K + artículo personal",
      "Traslados regulares de entrada y salida",
      "9 noches de alojamiento en Maceió Hotel Palms Ponta Verde by Tropicalis 4* con desayuno",
      "Seguro Asistencia al Viajero: INCLUIDO. ASSIST CARD. AC150. COBERTURA USD 150.000"
    ],
    recomendaciones: [
      "Explorar las dunas de Genipabu",
      "Disfrutar de las playas paradisíacas",
      "Visitar el Forte dos Reis Magos"
    ],
    descripcion: "Natal es la capital de Rio Grande do Norte, famosa por sus dunas de arena blanca, playas cristalinas y el sol que brilla durante todo el año. Un destino perfecto para los amantes de la naturaleza y las playas."
  },
  {
    ciudad: "Florianópolis",
    slug: "florianopolis",
    pais: "Brasil",
    hotel: "Hotel Palms Ponta Verde by Tropicalis 4*",
    noches: 7,
    regimen: "Desayuno",
    imagen: "/images/florianopolis.webp",
    iconos: ["vuelo", "hotel", "desayuno", "asistencia"],
    serviciosIncluidos: [
      "Ruta aérea estimada: Mendoza - Florianopolis - Mendoza",
      "Compañía aérea: GOL LINHEAS AEREAS",
      "Incluye carry on 10K + artículo personal",
      "Traslados regulares de entrada y salida",
      "7 noches de alojamiento en Maceió Hotel Palms Ponta Verde by Tropicalis 4* con desayuno",
      "Seguro Asistencia al Viajero: INCLUIDO. ASSIST CARD. AC150. COBERTURA USD 150.000"
    ],
    recomendaciones: [
      "Visitar las 42 playas de la isla",
      "Explorar el centro histórico",
      "Disfrutar de la gastronomía local"
    ],
    descripcion: "Florianópolis, conocida como 'Floripa', es una isla paradisíaca con más de 40 playas, desde las más tranquilas hasta las ideales para surf. Combina naturaleza exuberante con una vibrante vida urbana."
  },
  {
    ciudad: "Camboriú",
    slug: "camboriu",
    pais: "Brasil",
    hotel: "Hoteles 4 estrellas seleccionados",
    noches: 7,
    regimen: "Media pensión",
    imagen: "/images/camboriu.webp",
    iconos: ["vuelo", "hotel", "comidas", "asistencia", "equipaje"],
    serviciosIncluidos: [
      "Vuelo chárter 2026: Mendoza / Florianópolis / Mendoza (directo)",
      "Ticket aéreo: Mendoza / Florianópolis / Mendoza",
      "07 noches de alojamiento con media pensión",
      "Equipaje de 23 kg en bodega + artículo personal en cabina",
      "Coordinación permanente",
      "Asistencia al viajero 'Básica' con cobertura de USD 35.000"
    ],
    hotelesSeleccionados: [
      "BRUT",
      "HM PLAZA",
      "D'SINTRA",
      "Sistema de reservas",
      "MIRAMAR",
      "RIEGER"
    ],
    informacionHoteles: "Todos los hoteles son 4 estrellas y quedan a menos de 250mts de la playa",
    fechasSalida: {
      enero: ["11", "18", "25"],
      febrero: ["01", "08", "15"]
    },
    precios: [
      "SGL (Single): USD 1.900",
      "DBL (Double): USD 1.350",
      "TPL (Triple): USD 1.340",
      "PLAN FAM (2 adultos + 2 niños): USD 1.200",
      "CHD (Niño): USD 1.050",
      "INF (Infante): SOLO PAGA IMPUESTOS"
    ],
    notaImpuestos: "+ USD 250 DE IMPUESTOS (NO COMISIONABLES)",
    recomendaciones: [
      "Disfrutar de las hermosas playas de Camboriú",
      "Explorar los hoteles 4 estrellas a menos de 250mts de la playa",
      "Conocer la vibrante vida nocturna de la ciudad",
      "Visitar los balnearios y centros comerciales"
    ],
    descripcion: "Camboriú es un destino paradisíaco en la costa de Santa Catarina, Brasil, famoso por sus playas de arena blanca y aguas cristalinas. Con vuelo chárter directo desde Mendoza, ofrece hoteles 4 estrellas ubicados a menos de 250 metros de la playa, perfectos para una experiencia de relax y diversión. Salidas disponibles desde Mendoza en enero (11, 18, 25) y febrero (01, 08, 15)."
  },
  {
    ciudad: "Bayahíbe",
    slug: "bayahibe",
    pais: "República Dominicana",
    hotel: "Hotel Viva Miches by Wyndham 4*",
    noches: 10,
    regimen: "All Inclusive",
    imagen: "/images/bayahibe.webp",
    iconos: ["vuelo", "hotel", "comidas", "allinclusivebebidas", "wifi", "asistencia"],
    serviciosIncluidos: [
      "Ruta aérea estimada: Mendoza - Punta Cana - Mendoza",
      "Compañía aérea: LATAM AIRLINES",
      "Clase cotizada 'LIGHT'",
      "Incluye carry on 12K + artículo personal",
      "Traslados regulares de entrada y salida",
      "10 noches de alojamiento en Miches Hotel Viva Miches by Wyndham 4* con all inclusive",
      "Seguro Asistencia al Viajero: INCLUIDO. ASSIST CARD. AC150. COBERTURA USD 150.000"
    ],
    recomendaciones: [
      "Visitar el Parque Nacional del Este",
      "Explorar la Isla Saona",
      "Disfrutar de las playas de arena blanca"
    ],
    descripcion: "Bayahíbe es un pueblo pesquero tradicional que se ha convertido en un destino turístico popular, famoso por sus playas de arena blanca, aguas cristalinas y su proximidad al Parque Nacional del Este."
  },
  // CUBA
  {
    ciudad: "La Habana y Varadero",
    slug: "cuba-habana-varadero",
    pais: "Cuba",
    hotel: "Hotel 4* y 5*",
    noches: 9,
    regimen: "Desayuno y All Inclusive",
    imagen: "/images/habana.webp",
    iconos: ["vuelo", "hotel", "comidas", "allinclusivebebidas", "wifi", "asistencia", "visa"],
    serviciosIncluidos: [
      "Ruta aérea estimada: Mendoza - La Habana - Mendoza",
      "Compañía aérea: COPA/LATAM AIRLINES",
      "Clase cotizada 'BASIC'",
      "Incluye carry on 10K + artículo personal",
      "Visa cubana",
      "Traslados regulares de entrada y salida",
      "2 noches de alojamiento en La Habana Hotel 4* con desayuno",
      "7 noches de alojamiento en Varadero Hotel 5* con all inclusive",
      "Seguro Asistencia al Viajero: INCLUIDO. ASSIST CARD. AC150. COBERTURA USD 150.000"
    ],
    recomendaciones: [
      "Recorrer el casco histórico de La Habana",
      "Disfrutar de las playas de Varadero",
      "Experimentar la cultura cubana auténtica"
    ],
    descripcion: "Cuba ofrece una combinación única de historia, cultura y playas paradisíacas. Desde el encanto colonial de La Habana hasta las playas de arena blanca de Varadero, es un destino que cautiva con su autenticidad y belleza natural."
  },
  // CHILE
  {
    ciudad: "Santiago",
    slug: "santiago-chile",
    pais: "Chile",
    hotel: "Hotel 4*",
    noches: 7,
    regimen: "Desayuno",
    imagen: "/images/santiago-chile.png",
    iconos: ["vuelo", "hotel", "desayuno", "asistencia"],
    serviciosIncluidos: [
      "Ruta aérea estimada: Mendoza - Santiago - Mendoza",
      "Compañía aérea: SKY AIRLINES",
      "Clase cotizada 'BASIC'",
      "Incluye carry on 10K + artículo personal",
      "7 noches de alojamiento en Santiago Hotel 4* con desayuno",
      "Seguro Asistencia al Viajero: INCLUIDO. ASSIST CARD. AC150. COBERTURA USD 150.000"
    ],
    recomendaciones: [
      "Explorar el centro histórico",
      "Visitar el Cerro San Cristóbal",
      "Disfrutar de la gastronomía y vinos chilenos"
    ],
    descripcion: "Santiago de Chile es una metrópolis moderna que combina la tradición histórica con la innovación urbana. Conocida por su excelente gastronomía, vinos de clase mundial y su vibrante vida cultural."
  },
  {
    ciudad: "Sur de Chile",
    slug: "sur-chile",
    pais: "Chile",
    hotel: "Hoteles 4*",
    noches: 10,
    regimen: "Desayuno",
    imagen: "/images/sur-de-chile.webp",
    iconos: ["vuelo", "hotel", "desayuno", "asistencia"],
    serviciosIncluidos: [
      "Ruta aérea estimada: Mendoza - Santiago - Mendoza",
      "Compañía aérea: JET SMART",
      "Clase cotizada 'BASIC'",
      "Incluye carry on 10K + artículo personal",
      "2 noches de alojamiento en Santiago Hotel 4* con desayuno",
      "2 noches de alojamiento en Pucón Hotel 4* con desayuno",
      "1 noche de alojamiento en Valdivia Hotel 4* con desayuno",
      "3 noches de alojamiento en Puerto Montt Hotel 4* con desayuno",
      "1 noche de alojamiento en Chilán Hotel 4* con desayuno",
      "1 noche de alojamiento en Santiago Hotel 4* con desayuno"
    ],
    recomendaciones: [
      "Explorar los volcanes de Pucón",
      "Disfrutar de los lagos de la región",
      "Conocer la cultura mapuche"
    ],
    descripcion: "El sur de Chile ofrece paisajes espectaculares con volcanes, lagos cristalinos, bosques nativos y una rica cultura mapuche. Un destino perfecto para los amantes de la naturaleza y la aventura."
  },
  {
    ciudad: "Isla de Pascua",
    slug: "isla-pascua",
    pais: "Chile",
    hotel: "Hotel 4*",
    noches: 5,
    regimen: "Desayuno Continental",
    imagen: "/images/pascua.webp",
    iconos: ["vuelo", "hotel", "desayuno", "asistencia", "excursiones"],
    serviciosIncluidos: [
      "5 noches de alojamiento en hab Estandar",
      "Desayuno Continental Incluido",
      "Traslados in/out desde y hacia el aeropuerto de Mataveri en vuelos regulares",
      "Collar de bienvenida",
      "Medio día en Orongo",
      "Medio día en Akivi",
      "Full Day Akahanga, Rano Raraku – Tongariki – Te Pito Kura – Ahu Nau nau – Anaken",
      "Incluye: Sandwich, huevo duro, frutos secos, barra de cereal, fruta y 1 recarga",
      "Guía: incluye guía en inglés y en español"
    ],
    recomendaciones: [
      "Visitar los moáis y sitios arqueológicos",
      "Disfrutar de las playas de Anakena",
      "Experimentar la cultura rapanui"
    ],
    descripcion: "La Isla de Pascua (Rapa Nui) es uno de los destinos más místicos del mundo, famosa por sus enigmáticos moáis, playas de arena rosa y una cultura polinésica única. Un viaje inolvidable al corazón del Pacífico."
  },
  // PERÚ
  {
    ciudad: "Amaneceres del Inca",
    slug: "peru-amaneceres-inca",
    pais: "Perú",
    hotel: "Hoteles 3*, 4*, 5* según categoría",
    noches: 7,
    regimen: "Según itinerario",
    imagen: "/images/peru.webp",
    iconos: ["vuelo", "hotel", "comidas", "asistencia", "excursiones"],
    serviciosIncluidos: [
      "2 noches en Lima / 3 noches en Cusco / 1 noche en Urubamba / 1 noche en Machu Picchu",
      "Traslado privado desde el aeropuerto de Lima a su hotel con un representante",
      "Tour compartido de medio día en Lima a Casa Aliaga, Catedral y Museo Larco",
      "Traslado privado desde su hotel al aeropuerto de Lima con chofer trasladista",
      "Traslado privado desde el aeropuerto de Cusco a su hotel con un representante",
      "Tour compartido de medio día en Cusco a Coricancha, Catedral, Sacsayhuamán, Qenqo, Puca Pucara y Tambomachay",
      "Boleto Turístico Completo de Cusco (BTC total)",
      "Tour compartido de medio día a Moray y Maras desde/hasta Cusco",
      "Tour compartido de día completo a Chinchero, el Museo Vivo de Yucay y Ollantaytambo desde/hasta Cusco",
      "Traslado compartido desde su hotel en Urubamba (Valle Sagrado) a la estación de Ollantaytambo con un representante",
      "Tren Voyager de ida y 360° de retorno desde/hasta la estación de Ollantaytambo",
      "Tour compartido para 2 días y 1 noche a Machu Picchu con un guía de sitio",
      "Almuerzo menú en el Café Inkaterra",
      "Traslado compartido desde la estación de Ollantaytambo hasta su hotel en Cusco",
      "Traslado privado desde su hotel al aeropuerto de Cusco con un representante"
    ],
    serviciosNoIncluidos: [
      "Bebidas alcohólicas y no alcohólicas durante las comidas",
      "Comidas no mencionadas en el itinerario",
      "Boletos aéreos nacionales e internacionales",
      "Early check in, late check out",
      "Propinas",
      "Seguro de viaje"
    ],
    precios: [
      "PRECIO USD 975 POR PERSONA BASE DOBLE – CATEGORÍA TURISTA",
      "PRECIO USD 1050 POR PERSONA BASE DOBLE – CATEGORÍA TURISTA SUPERIOR",
      "PRECIO USD 1100 POR PERSONA BASE DOBLE – CATEGORÍA PRIMERA"
    ],
    recomendaciones: [
      "Visitar Machu Picchu al amanecer para una experiencia única",
      "Explorar el Valle Sagrado y sus sitios arqueológicos",
      "Conocer la cultura inca en Cusco y sus alrededores",
      "Disfrutar de la gastronomía peruana reconocida mundialmente",
      "Aclimatarse adecuadamente a la altura de Cusco"
    ],
    descripcion: "Amaneceres del Inca es un tour completo de 8 días y 7 noches que te lleva por los destinos más emblemáticos de Perú. Desde Lima hasta la mágica Machu Picchu, pasando por Cusco y el Valle Sagrado, este itinerario incluye traslados privados, tours compartidos, el Boleto Turístico Completo de Cusco, y una experiencia inolvidable en el tren hacia Machu Picchu. Disponible en tres categorías: Turista, Turista Superior y Primera."
  },
  // USA
  {
    ciudad: "New York",
    slug: "new-york",
    pais: "USA",
    hotel: "Hoteles 4*, 5*",
    noches: 7,
    regimen: "Solo alojamiento",
    imagen: "/images/newyork.webp",
    iconos: ["vuelo", "hotel", "asistencia", "visa"],
    serviciosIncluidos: [
      "Aéreos Mendoza - New York - Mendoza",
      "Traslados regulares de entrada y salida",
      "7 noches de alojamiento en New York Hoteles 4*, 5* solo alojamiento",
      "Seguro Asistencia al Viajero: INCLUIDO. ASSIST CARD AC150. COBERTURA USD 150.000",
      "Asistencia BELUTOURS 24/7 durante tu viaje"
    ],
    recomendaciones: [
      "Visitar Times Square y Broadway",
      "Subir al Empire State Building",
      "Recorrer Central Park y la Estatua de la Libertad"
    ],
    descripcion: "New York es la ciudad que nunca duerme, un destino icónico con rascacielos imponentes, museos de clase mundial, teatros de Broadway y una energía única que la convierte en una de las ciudades más fascinantes del mundo.",
    requisitos: "PASAPORTE VIGENTE + VISA AMERICANA"
  },
  {
    ciudad: "Miami",
    slug: "miami",
    pais: "USA",
    hotel: "Hoteles 4*, 5*",
    noches: 7,
    regimen: "Solo alojamiento",
    imagen: "/images/miami.webp",
    iconos: ["vuelo", "hotel", "asistencia", "visa"],
    serviciosIncluidos: [
      "Aéreos Mendoza - Miami - Mendoza",
      "7 noches de alojamiento en Miami hoteles 4*, 5* solo alojamiento",
      "Seguro Asistencia al Viajero: INCLUIDO. ASSIST CARD. AC150. COBERTURA USD 150.000",
      "Asistencia BELUTOURS 24/7 durante tu viaje"
    ],
    recomendaciones: [
      "Disfrutar de las playas de South Beach",
      "Explorar el Art Deco District",
      "Visitar los Everglades y Little Havana"
    ],
    descripcion: "Miami es sinónimo de playas doradas, vida nocturna vibrante, arte y cultura. Con su mezcla única de influencias latinas y estadounidenses, ofrece una experiencia tropical urbana incomparable.",
    requisitos: "PASAPORTE VIGENTE + VISA AMERICANA"
  },
  // DESTINOS NACIONALES
  {
    ciudad: "Calafate",
    slug: "calafate",
    pais: "Argentina",
    hotel: "Hotel Bahia Redonda 3*",
    noches: 3,
    regimen: "Desayuno",
    imagen: "/images/calafate.webp",
    iconos: ["vuelo", "hotel", "desayuno", "asistencia", "excursiones"],
    serviciosIncluidos: [
      "Ruta aérea estimada: Mendoza - Calafate - Mendoza",
      "Compañía aérea: AEROLINEAS ARGENTINAS",
      "Clase cotizada 'BASE'; otras aplican diferencias tarifarias",
      "Incluye artículo personal",
      "Traslados regulares de entrada y salida",
      "Excursión Perito Moreno *SIN ENTRADA*",
      "3 noches de alojamiento en Calafate Hotel Bahia Redonda 3* con desayuno",
      "Seguro Asistencia al Viajero: INCLUÍDO"
    ],
    recomendaciones: [
      "Visitar el Glaciar Perito Moreno",
      "Explorar el Parque Nacional Los Glaciares",
      "Navegar por el Lago Argentino",
      "Conocer el cerro Fitz Roy"
    ],
    descripcion: "El Calafate es la puerta de entrada al Parque Nacional Los Glaciares, hogar del famoso Glaciar Perito Moreno. Un destino único donde la naturaleza se muestra en su máxima expresión con glaciares, lagos y montañas imponentes."
  },
  {
    ciudad: "Ushuaia",
    slug: "ushuaia",
    pais: "Argentina",
    hotel: "Hotel 3*, 4*, 5*",
    noches: 4,
    regimen: "Desayuno",
    imagen: "/images/Ushuaia.webp",
    iconos: ["vuelo", "hotel", "desayuno", "asistencia", "excursiones"],
    serviciosIncluidos: [
      "Aéreo desde Mendoza",
      "Traslados aeropuerto hotel aeropuerto",
      "Alojamiento Hotel 3*, 4*, 5* con desayuno",
      "Excursión al Parque Nacional Tierra del Fuego",
      "Tren del Fin del Mundo",
      "Asistencia al viajero",
      "Asistencia BELUTOURS 24/7 durante tu viaje"
    ],
    recomendaciones: [
      "Recorrer el Parque Nacional Tierra del Fuego",
      "Viajar en el Tren del Fin del Mundo",
      "Esquiar en Cerro Castor",
      "Navegar por el Canal de Beagle"
    ],
    descripcion: "Ushuaia, la ciudad más austral del mundo, es un destino único donde termina la Patagonia y comienza la Antártida. Con sus paisajes únicos, el Tren del Fin del Mundo y el Parque Nacional Tierra del Fuego, ofrece una experiencia inolvidable."
  },
  {
    ciudad: "Mar del Plata",
    slug: "mar-del-plata",
    pais: "Argentina",
    hotel: "Hotel Valles 3* SUP",
    noches: 7,
    regimen: "Desayuno",
    imagen: "/images/mar-del-plata.png",
    iconos: ["hotel", "desayuno", "asistencia"],
    serviciosIncluidos: [
      "Bus semicama desde Mendoza (opcional coche cama)",
      "Desayuno a bordo",
      "07 noches de alojamiento con desayuno (opcional media pensión)",
      "Coordinación permanente",
      "Asistencia al viajero 'Básica' con cobertura de ARS 200.000"
    ],
    fechasSalida: {
      enero: ["4", "11", "18", "25"],
      febrero: ["1", "8", "15"],
      carnaval: "CARNAVAL"
    },
    precios: [
      "4-11-18 enero - PROMO: $850.000 / LISTA: $940.000",
      "25 enero - PROMO: $790.000 / LISTA: $875.000",
      "1-8 febrero - PROMO: $820.000 / LISTA: $907.000",
      "CARNAVAL - PROMO: $850.000 / LISTA: $940.000",
      "15 febrero - LISTA: $940.000"
    ],
    notaPrecios: "Tarifas PROMO SOLO CONTADO (EFECTIVO Y TRANSFERENCIAS A MERCADO PAGO). Tarifas por pasajero en base: Doble-Triple. Single: adicionar 50%. Tarifas sujetas a cambios y disponibilidad sin previo aviso.",
    comidasOpcionales: {
      titulo: "OPCIONAL: 7 Comidas en Restaurantes",
      restaurantes: [
        "(2) MONTECATINI - SUCURSAL SANTA FE 1744",
        "(3) COCINA MAMA - BELGRANO 2239",
        "(2) RAMIRO - LA TROCHA - CORRIENTES 1965"
      ],
      precios: [
        "TARIFA x 7 comidas PROMO: $200.000",
        "PRECIO LISTA: $225.000"
      ]
    },
    costosAdicionales: [
      "ADICIONAL BUTACA CAMA: $70.000",
      "PANORAMICAS Y CAFETERAS: $40.000",
      "DOBLE PERIODO Y SIN TRANSPORTE: Descontar $100.000",
      "PASAJEROS DE SAN JUAN: Descontar $20.000"
    ],
    horariosEmbarque: {
      ruta7: {
        titulo: "RUTA 7",
        horarios: [
          "SALIDA DE MENDOZA: 15:00",
          "SAN MARTIN: 15:40",
          "SAN LUIS: 18:40",
          "V MERCEDES: 20:40"
        ],
        descuento: "EMBARQUES EN SAN LUIS: Descontar $20.000"
      },
      ruta40: {
        titulo: "RUTA 40",
        horarios: [
          "SALIDA DE MENDOZA: 15:00",
          "TUNUYAN: 16:40",
          "SAN RAFAEL: 18:30",
          "GRAL. ALVEAR: 20:40"
        ]
      }
    },
    asistenciaViajero: {
      menores: "Menores hasta 3 años inclusive: adicionar $8.000",
      mayores: "Mayores a partir de 76 años: adicionar $3.500",
      cobertura: "Cobertura básica máxima $200.000. Consulte prestaciones y condiciones generales."
    },
    noIncluye: [
      "Comidas en viaje",
      "Bebidas en las cenas",
      "Propinas de maleteros"
    ],
    politicaMenores: "Menores de hasta 3 años inclusive: Viajarán sin cargo, sin servicio deben pagar seguro $8.000 netos (compartiendo habitación por lo menos con 2 adultos).",
    politicaReserva: "La reserva se concreta abonando el 30% del paquete, se congela únicamente con el pago 100%.",
    recomendaciones: [
      "Disfrutar de las playas del microcentro a solo 4 cuadras del hotel",
      "Explorar el centro histórico y la rambla",
      "Visitar el Casino y el Puerto",
      "Disfrutar de la gastronomía marplatense"
    ],
    descripcion: "Mar del Plata, conocida como 'La Perla del Atlántico', es la ciudad balnearia más importante de Argentina y uno de los destinos turísticos más elegidos del país. Ubicada estratégicamente en pleno microcentro a solo 4 cuadras de las hermosas playas del Atlántico, ofrece una combinación perfecta de relax, entretenimiento y cultura. La ciudad se caracteriza por sus extensas playas de arena fina, desde las más familiares como Bristol y Varese hasta las más exclusivas de la zona sur. Su famosa rambla costera, con más de 8 kilómetros de extensión, es ideal para caminatas, paseos en bicicleta y disfrutar de espectaculares atardeceres sobre el mar. El Hotel Valles 3* SUP, ubicado en Av. Luro 2487, se encuentra en el corazón del microcentro marplatense, a solo 4 cuadras de la playa, ofreciendo amplio desayuno buffet, sala de estar con TV por cable, atención médica 24hs, ascensores, Wi-Fi sin cargo, habitaciones con aire acondicionado, TV LCD, frigobar, teléfono con DDI y DDN, calefacción central y cajas de seguridad individuales. Mar del Plata también es reconocida por su vibrante vida nocturna, el imponente Casino Central, el pintoresco Puerto de Mar del Plata donde se puede disfrutar de la mejor gastronomía con pescados y mariscos frescos, y una amplia oferta cultural con museos, teatros y centros de arte. La ciudad combina la elegancia de su arquitectura de principios del siglo XX con modernos centros comerciales, creando un ambiente único que atrae a visitantes de todas las edades durante todo el año. VIGENTES a partir del 4 NOVIEMBRE."
  }
];
